module.exports = __webpack_public_path__ + "img/121.f0c7874d.jpg";